import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import WelcomeToBlueElegance from "./sections/WelcomeToBlueElegance";
import StreamlinedSuccessPath from "./sections/StreamlinedSuccessPath";
import TheMortgagenieReassurance from "./sections/TheMortgagenieReassurance";
import TrustAccountability from "./sections/TrustAccountability";
import TheCommandCenter from "./sections/TheCommandCenter";
import About from "./sections/About";
import ReadyToEvolve from "./sections/ReadyToEvolve";
import CommonQuestions from "./sections/CommonQuestions";
import StructuralFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <WelcomeToBlueElegance />
      <StreamlinedSuccessPath />
      <TheMortgagenieReassurance />
      <TrustAccountability />
      <TheCommandCenter />
      <About />
      <ReadyToEvolve />
      <CommonQuestions />
      <StructuralFooter />
    </div>;
}